import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import useToken from '../../useToken';
import { useAuth } from '../../contexts/AuthContext';
import { useSelector, useDispatch } from 'react-redux';
import { fetchReport } from '../../features/cultivation_report/cultivationReportSlice';
import Table from './TopTenYieldTable';
import Chart from './Chart';
import { Select, MenuItem, InputLabel, FormControl, Button } from '@material-ui/core';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import * as CsvExporter from '../../CsvExporter';
import { CSVLink } from "react-csv";

const theme = createTheme({
  palette: {
    primary: { main: green[500], contrastText: "#fff" },
  },
});
const useStyles = makeStyles ({
      root: {
              display: 'flex',
            },
      toolbar: {
              paddingRight: 24, // keep right padding when drawer closed
            },
      toolbarIcon: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              padding: '0 8px',
            },
      menuButton: {
              marginRight: 36,
            },
      menuButtonHidden: {
              display: 'none',
            },
      title: {
              flexGrow: 1,
            },
      content: {
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            },
      container: {
              paddingTop: 1,
              paddingBottom: 1,
            },
      paper: {
              display: 'flex',
              flexDirection: 'column',
            },
      fixedHeight: {
              height: 400,
            },
      formControl: {
        margin: 10,
        marginLeft: 30,
        minWidth: 300,
      },
      buttonMargin: {
        marginTop: 20,
      },
      selectEmpty: {
        marginTop: 10,
      },
      link: {
        textDecoration: 'none', 
        color: "#657a71",
        marginRight: 20,
        margin:10,
        border:1 ,  
      }
});

const CultivationReport = () => {
  const [model, setModel] = React.useState("")
  const [crop, setCrop] = React.useState("")

  const {token, setToken} = useToken()
  const { logout } = useAuth()
  const dispatch = useDispatch()
  const report = useSelector((state: any) => state.cultivation_report.reportData);
  const cultivationModels = report.cultivationModels || [];
  
  useEffect(() => {
    dispatch(fetchReport({token, model, crop}))
  }, [dispatch]);

  if (report.error === "unauthorized") {
    logout()
    window.location.reload();
  }
  
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    
  const handleModel = (event) => {
    setModel(event.target.value)
  }

  const handleCrop = (event) => {
    setCrop(event.target.value)
  }

  const exportCSV = CsvExporter.getCultivation({cults: report.TopTenYields})

    if (report.status === "idle") { 
        return (
         <Container maxWidth="lg" className={classes.container}>
         <h1>Cultivation Report</h1>
         
         <Grid container>
         <Grid item xs={5}>
         <FormControl className={classes.formControl}>
         <InputLabel id="model-label">Select Cultivation Model</InputLabel>
         <Select
          labelId="model-label"
          id="model"
          value={model}
          onChange={handleModel}
         >
          { 
              cultivationModels.map((model, index) => {
                return <MenuItem key={index} value={model}>{model}</MenuItem>
              }  
          )}
        </Select>
        </FormControl>
         </Grid>

         <Grid item xs={5}>
         <FormControl className={classes.formControl}>
         <InputLabel id="crop-label">Select crop</InputLabel>
         <Select
          labelId="crop-label"
          id="crop"
          value={crop}
          onChange={handleCrop}
         >
          { 
              report.crops.map((crop, index) => {
                return <MenuItem key={index} value={crop}>{crop}</MenuItem>
              }
          )}
        </Select>
        </FormControl>
         </Grid>

         <Grid item xs={2}>
         <ThemeProvider theme={theme}>
          <Button className={classes.buttonMargin} variant="contained" 
          color="primary" onClick={() => dispatch(fetchReport({token, model, crop}))}>Confirm</Button>
         </ThemeProvider>
         </Grid>

         </Grid>

         <Grid container>
         <Grid item xs={12}>
         <Paper className={fixedHeightPaper}>
           <Chart data={report.data} />
         </Paper>
         </Grid>
         </Grid>
         <br/>
         <Grid container>
         <Grid item xs={12}>
         <Paper className={fixedHeightPaper}>
         <Grid container justifyContent="flex-end">
            <CSVLink className={classes.link} 
              filename={exportCSV.filename}
              headers={exportCSV.header}
              data={exportCSV.data}>
              <Button variant="outlined">Export CSV</Button>
            </CSVLink>
         </Grid>
            <Table data={report.TopTenYields} />
         </Paper>
         </Grid>
         </Grid>
         <Box pt={4}>
         </Box>
         </Container>

        )
    } else {
      return (<h3> loading </h3>)
    }
  }

export default CultivationReport
